<template>
  <div>
    <Candidate :source="resume" :isResume="false"></Candidate>
    <div>教育经历</div>
  </div>
</template>

<script>
  import Api from "@/api";
  import Candidate from './candidate'
  export default {
    components: {
      Candidate
    },
    props: {
      resume:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data() {
      return {
        
      }
    },
    mounted() {
      
    },
    methods:{
      
    }
  }
</script>

<style>
</style>
